import './Card.css';
import ManaCost from "./ManaCost";
import UnitAD from "./UnitAD";
import {useActions} from "../../hooks/useActions";
import parse from 'html-react-parser';
import Name from "./Name/Name";
import {AutoTextSize} from "auto-text-size";
import Amount from "../menu/deck/Amount";
import {useTypedSelector} from "../../hooks/useTypedSelector";
import {config} from "../../config";


function Card({
                  card,
                  targetClasses = '',
                  isHand = false,
                  isSmall = false,
                  isBigSize = false,
                  isVeryBigSize = false,
                  isBattle = false,
                  AmountNum = null
              }: any) {

    const {setCardBigSize} = useActions();

    const {game} = useTypedSelector(state => state.game);

    let cardRootClasses = game !== null ? 'cardContainerGame' : 'cardContainer';

    let abTextUnitFont = 10;


    let cardImageClass = ' cardImage';
    let cardImageContainerClass = ' cardImageContainer';
    let cardCornerBordersSmallClass = '';

    if (isSmall) {
        cardImageContainerClass = ' cardImageContainerSmall'
        cardImageClass = ' cardImageSmall';
        cardRootClasses += ' cardContainerSmall';
        cardCornerBordersSmallClass = ' cardCornerBordersSmall';
    }

    if (isHand) {
        cardRootClasses += ' cardContainerSmallHand'
    }

    if (isBigSize) {
        cardRootClasses = ' cardContainerBig';
        abTextUnitFont = 14;
    }

    if (isVeryBigSize) {
        cardRootClasses = ' cardContainerVeryBig';
        cardCornerBordersSmallClass = ' cardCornerBordersVeryBig';
        abTextUnitFont = 16;
    }

    const getCardImageSrc = (cardId: number) => {
        if (config.isWindows) {
            return `./img/cards/mini/${cardId}.webp`; // локально
        }
        if (config.isAndroid) {
            return `img/cards/mini/${cardId}.webp`; // локально
        }

        return `${config.cdnUrl}/img/cards/mini/${cardId}.webp`; // CDN
    };

    return (
        <div className={cardRootClasses}
             onDoubleClick={() => {
                 if (isVeryBigSize === true) {
                     return;
                 }
                 setCardBigSize(card);
             }
             }
             onContextMenu={(event) => {
                 event.preventDefault();

                 if (isVeryBigSize === true) {
                     return;
                 }
                 setCardBigSize(card);
                 return false;
             }}
        >
            {(AmountNum !== null) ?
                <Amount amount={AmountNum} />
                :
                null
            }

            <div className={'rightBorderCorner rightBorderCornerBG-' + card.level + cardCornerBordersSmallClass}></div>
            <div className={'leftBorderCorner leftBorderCornerBG-' + card.level + cardCornerBordersSmallClass}></div>
            <div className={targetClasses + ' cardTargetBorder'}></div>
            <div className={'cardBorder cardBorderBG-' + card.level}></div>

            <Name card={card} isSmall={isSmall} isHand={isHand} isBigSize={isBigSize} isVeryBigSize={isVeryBigSize}/>

            {(!isSmall || isHand) ?
                <ManaCost costs={card.cost} level={card.level} isBigSize={isBigSize} isVeryBigSize={isVeryBigSize}/>
                :
                <div></div>
            }

            {(card.ab_text) ?
                <div className='abilityText'>

                    <AutoTextSize mode={'box'} minFontSizePx={abTextUnitFont}
                                  maxFontSizePx={abTextUnitFont + 2}>  {parse('<span>' + card.ab_text + '</span>')} </AutoTextSize>

                </div>
                :
                <div></div>
            }

            {(card.type_card === 'unit') ?
                <UnitAD attack={card.attack} hp={card.hp} level={card.level} isSmall={isSmall} isBigSize={isBigSize}
                        isVeryBigSize={isVeryBigSize} isBattle={isBattle}/>
                :
                <div></div>
            }

            <div className={cardImageContainerClass}>
                <img
                    src={getCardImageSrc(card.id)}
                    className={cardImageClass}
                    loading="eager"
                />
            </div>

        </div>
    );
}

export default Card;